import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back.");
      nav(user.paid_entry ? "/feed" : "/pay-entry");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="max-w-md mx-auto px-4 py-16">
      <h1 className="font-display font-black text-5xl tracking-tighter uppercase">Log in.</h1>
      <p className="mt-3 text-[#0A0A0A]/70">Welcome back to Bitbook.</p>

      <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="login-form">
        <div>
          <label className="text-xs font-bold uppercase tracking-widest">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="mt-2 w-full px-4 py-3 bg-white border-2 border-black font-mono focus:outline-none focus:ring-2 focus:ring-[#F7931A] focus:ring-offset-2"
          />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-widest">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="mt-2 w-full px-4 py-3 bg-white border-2 border-black font-mono focus:outline-none focus:ring-2 focus:ring-[#F7931A] focus:ring-offset-2"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full py-4 bg-[#F7931A] border-2 border-black font-bold uppercase tracking-widest btn-brutal disabled:opacity-60"
        >
          {loading ? "..." : "Log in"}
        </button>
      </form>
      <div className="mt-6 text-sm">
        No account?{" "}
        <Link to="/register" className="font-bold underline decoration-[#F7931A] decoration-2 underline-offset-4">
          Create one
        </Link>
        .
      </div>
    </main>
  );
}
